import {deleteRequest, getRequest, postRequest, putRequest} from '../client';
import {
  CreateParams,
  CustomParams,
  DataProvider,
  DeleteManyParams,
  DeleteOneParams,
  GetListParams,
  GetManyParams,
  GetOneParams,
  UpdateManyParams,
  UpdateParams,
} from '@refinedev/core';
import {Params_to_QueryString} from './utils';
import getFormData from '../getFormData';

const apiUrl = '/api'; //`${config.backendHost}/api`;

function getApiUrl(): string {
  return apiUrl;
}

const getList = async (params: GetListParams) => {
  const {resource} = params;
  const url = `${apiUrl}/${resource}`;

  const query = Params_to_QueryString(params);

  //resp:{data,headers, ...}
  //data:{data:[],total,page,....}
  const result = await getRequest(`${url}${query}`); //

  return {
    data: result?.data || result,
    total: result?.total || result?.data?.length,
    pageInfo: {
      hasNextPage: Boolean(result?.next_page_url),
      hasPreviousPage: Boolean(result?.prev_page_url),
    },
  };
};

const getOne = async (params: GetOneParams) => {
  const {resource} = params;
  const url = `${apiUrl}/${resource}/${params.id}`;
  const {meta} = params;
  const query = Params_to_QueryString({meta});

  // const {data} = await apiClient.get(`${url}${query}`);
  const data = await getRequest(`${url}${query}`);

  return {
    data,
  };
};

const getMany = async ({resource, ...params}: GetManyParams) => {
  const url = `${apiUrl}/${resource}/${JSON.stringify(params.ids)}`;
  const {meta} = params;
  const query = Params_to_QueryString({meta});
  // const {data} = await apiClient.get(`${url}/${query}`);
  const data = await getRequest(`${url}/${query}`); //await apiClient.get(`${url}/${query}`);

  return {
    data,
  };
};

// const getManyReference = async (resource, params) => {
//   const {target, id, pagination, sort: sorters, meta, filter} = params;
//   var filter2 = {...filter, [target]: id};
//   const params2 = {
//     pagination,
//     filters: filter2,
//     sorters,
//     meta,
//   };

//   return await getList({resource, ...params2});
// };

const create = async (params: CreateParams<any>) => {
  const {resource} = params;
  const url = `${apiUrl}/${resource}`;

  var input = params.variables;
  input = getFormData(input);
  // if (params.meta?.attachmentFields) {
  //   // input = getFormDataForUpload(input, params.meta?.attachmentFields);
  //   input = getFormData(input);
  // }

  // const {data} = await apiClient.post(url, input);
  const data = await postRequest(url, input); //await apiClient.post(url, input);

  return {
    data,
  };
};

const update = async (params: UpdateParams<any>) => {
  const {resource} = params;
  const url = `${apiUrl}/${resource}/${params.id}`;

  var input = params.variables;
  input = getFormData(input);

  // if (params.meta?.attachmentFields) {
  //   input = getFormDataForUpload(input, params.meta?.attachmentFields);
  // }

  var data: any = null;
  if (input instanceof FormData) {
    /// fix ugly bug of laravel: https://github.com/laravel/framework/issues/13457
    data = await postRequest(url + '?_method=PUT', input); //await apiClient.post(url + '?_method=PUT', input);
  } else {
    data = await putRequest(url, input); //await apiClient.put(url, input);
  }
  return {data};
};

const updateMany = async (params: UpdateManyParams<any>) => {
  throw 'Not implemented';
  // const {data} = await apiClient.put(
  //   `${apiUrl}/${resource}/${JSON.stringify(params.ids)}`,
  //   params.data,
  // );

  // return {data};
};

const deleteOne = async (params: DeleteOneParams<any>) => {
  const {resource} = params;
  const url = `${apiUrl}/${resource}/${params.id}`;

  // const {data} = await apiClient.delete(url);
  const data = await deleteRequest(url); //await apiClient.delete(url);

  return {data};
};

const deleteMany = async (params: DeleteManyParams<any>) => {
  const {resource} = params;
  const url = `${apiUrl}/${resource}/${JSON.stringify(params.ids)}`;
  // const {data} = await deleteRequest(url); //await apiClient.delete(url);
  const data = await deleteRequest(url); //await apiClient.delete(url);
  return {data};
  // const response = await Promise.all(
  //   params.ids.map(async id => {
  //     const {data} = await apiClient.delete();
  //     return data;
  //   }),
  // );
  // return {data: response};
};

// const custom = async (params: CustomParams) => {
//   const {url: inputUrl} = params;
//   const url = `${apiUrl}/${inputUrl}`;
//   const data = await getRequest(url);
//   return {data};
// };

const dataProvider: DataProvider = {
  getList,
  getOne,
  getMany,
  create,
  update,
  updateMany,
  deleteOne,
  deleteMany,
  getApiUrl,
  // custom,  
};

export default dataProvider;
